import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
//import { Redirect, Route, Switch } from "react-router";
import io from "socket.io-client";
import { BASEURL } from "../../utilites";
// Dashboard import
import OnBoard from "../../pages/dashboard/OnBoard";
import UnderReview from "../../pages/dashboard/UnderReview";
//import Otp from "../../pages/auth/Otp";
import ContactSupportImage from '../../assets/img/contact-support.png'

const ProtectDashboard = ({ Component }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user] = useSelector((state) => [state.user]);
  // if (user?.LoginData?.authorization==1 || user?.error=='session expired') {
  //   return <Otp/>;

  // }else{
  const ContactSupport = () => {
    const isInactive = user.statusId === 6;
    return (
      <div className="d-flex flex-column align-items-center justify-content-center mt-5" >
        {isInactive ? (
          <div className="text-center">
            <h2 className="text-dark">Your subscription has expired</h2>
            <p className="text-muted mt-2 mb-4">Resubscribe to a plan to restore access to your account, or contact support for assistance.</p>
            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                className="btn btn-primary btn-lg px-5"
                onClick={() => navigate('/dashboard/membership')}
              >
                Resubscribe Now
              </button>
              <a href="tel:+12136064143" className="btn btn-secondary btn-lg px-4">
                Call Support
              </a>
            </div>
            <p className="text-muted mt-3 small">Call: +1 (213) 606-4143</p>
          </div>
        ) : (
          <div>
            <h2 className="text-dark text-center">Ouch! Looks like you have been locked out. Please contact support.</h2>
            <h2 className="text-dark text-center">Call: +1 (213) 606-4143.</h2>
          </div>
        )}
        <img src={ContactSupportImage} alt="Contact Support" style={{width:'100%', maxWidth:'500px'}} />
      </div>
    )
  }
  useEffect(() => {
    const socket = io(BASEURL, { transports: ["websocket"] });
    // Event listeners for various socket events
    socket.on("connect", () => {
      console.log("Connected to server");
      if (user && user.LoginData) {
        socket.emit("clientData", user.LoginData.uuid);
      }
      socket.on("disconnect", () => {
        console.log("Disconnected from server");
      });
    });
    // Other event listeners and logic
    return () => {
      socket.disconnect();
    };
  }, [user]);

  useEffect(() => {
    const currentTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-bs-theme", currentTheme);
    // Validate user theme
    if (user && user.LoginData) {
      const theme = user.LoginData?.settings?.theme;
      // Set user theme
      localStorage.setItem("theme", theme);
      document.documentElement.setAttribute("data-bs-theme", theme);
    }

    return () => {
      document.documentElement.removeAttribute("data-bs-theme");
    };
  }, [user]);

  const roleSwappedPath = useMemo(() => {
    const path = location.pathname;
    const taxProToCustomer = [
      [/^\/dashboard\/jobs\/(?!create\b|edit\b)([^/]+)(\/.*)?$/, "/dashboard/projects/$1$2"],
      [/^\/dashboard\/job\/([^/]+)\/([^/]+)(\/.*)?$/, "/dashboard/project/$1/$2$3"],
    ];
    const customerToTaxPro = [
      [/^\/dashboard\/projects\/([^/]+)(\/.*)?$/, "/dashboard/jobs/$1$2"],
      [/^\/dashboard\/project\/([^/]+)\/([^/]+)(\/.*)?$/, "/dashboard/job/$1/$2$3"],
    ];
    const rules = user.isTaxPro
      ? customerToTaxPro
      : user?.LoginData?.isCustomer
      ? taxProToCustomer
      : null;
    if (!rules) return null;
    for (const [re, replacement] of rules) {
      if (re.test(path)) {
        const swapped = path.replace(re, replacement) + location.search + location.hash;
        return swapped === path + location.search + location.hash ? null : swapped;
      }
    }
    return null;
  }, [location.pathname, location.search, location.hash, user.isTaxPro, user?.LoginData?.isCustomer]);

  if (roleSwappedPath) {
    return <Navigate to={roleSwappedPath} replace />;
  }

  if (user.isTaxPro) {
    switch (user.statusId) {
      case 0:
        if (user.statusId === 0) {
          if (location.pathname === "/dashboard/messages") return <Component />;
          return <OnBoard />;
          // if (location.pathname == "/dashboard/onboard") {
          // } else {
          //   navigate("/dashboard/onboard");
          // }
        }
        break;
      case 1:
        if (user.statusId === 1) {
          if (location.pathname === "/dashboard/messages") return <Component />;
          if (location.pathname === "/dashboard/settings") return <Component />;
          return <UnderReview />;
          // if (location.pathname == "/dashboard/underReview") {
          // } else {
          //   navigate("/dashboard/underReview");
          // }
        }
        break;
      case 2:
        if (user.statusId === 2) {
          if (!Component || location.pathname === "/dashboard/users") {
            navigate("/dashboard/");
            return;
          }
          return <Component />;
        }
        break;
      case 3:
        if (user.statusId === 3) {
          if (!Component) {
            navigate("/dashboard/");
            return;
          }
          return <Component />;
        }
        break;
           case 5:
        if (user.statusId === 5) {
          if (!Component) {
            navigate("/dashboard/");
            return;
          }
          return <ContactSupport />; 
        }
        break;
        case 6:
          if (user.statusId === 6 ) {
            // Allow access to billing, membership, and checkout so user can resubscribe
            const allowedPaths = ['/dashboard/billing', '/dashboard/membership', '/dashboard/checkout', '/dashboard/confirmed', '/dashboard/settings', '/dashboard/messages'];
            if (allowedPaths.some(p => location.pathname.startsWith(p))) {
              return <Component />;
            }
            if (!Component) {
              navigate("/dashboard/");
              return;
            }
            return <ContactSupport />;
          }
          break;
      default:
        break;
    }
  } else if (user?.LoginData?.isCloser) {
    // Closer users should only access Internal Checkout + Settings (edit profile).
    const allowedPaths = ['/dashboard/internal-checkout', '/dashboard/settings'];
    if (allowedPaths.some((p) => location.pathname.startsWith(p))) {
      return <Component />;
    }
    navigate('/dashboard/internal-checkout');
    return null;
  } else if (
    user.isAdmin ||
    user.isRegular ||
    user.LoginData.isAccountManager
  ) {
    return <Component />;
  }
  // }
};
export default ProtectDashboard;
